module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    key: _vm.item.id,
    class: {
      'is-archived': _vm.isArchived
    }
  }, [_c('td', [_vm._v(_vm._s(_vm.item.code))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "60%",
      "position": "relative"
    }
  }, [(_vm.isShowModal) ? _c('CostCentersCenterCalendarsModal', {
    attrs: {
      "calendars": _vm.calendars,
      "selected-ids": _vm.selectedIds
    },
    on: {
      "close": function($event) {
        _vm.isShowModal = false
      },
      "submit": _vm.onModalSubmit
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "cost-center-actions"
  }, [(!_vm.isInSchoolSalarySettings && !_vm.isArchived) ? _c('div', {
    staticClass: "click-container",
    on: {
      "!click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.isShowModal = true
      }
    }
  }, [_c('DoFiltersFilter', {
    attrs: {
      "title": 'Kalendere',
      "tags": _vm.calendarNames,
      "numberOfSelectedTagsToShow": 20,
      "selectedTags": _vm.selectedNames
    },
    on: {
      "select": _vm.noop,
      "clear": _vm.noop,
      "close": _vm.noop
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isArchived) ? _c('button', {
    staticClass: "do-bttn do-bttn--small",
    class: {
      'do-bttn--loading': _vm.isUpdating
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('archive', _vm.item)
      }
    }
  }, [_vm._v("\n        Arkivér\n      ")]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-03a53a2c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SchoolSettings/CostCentersCenter.vue
// module id = 1734
// module chunks = 1